module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "Shop Smart at Grocery Stores"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg3_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1a",
    attrs: {
      "id": "ch01_1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('strong', [_vm._v("Shop Smart at Grocery Stores")])])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Buying healthy food on a tight budget can be a challenge, but the more you know, the easier it is to buy nutritious foods without exceeding your budget. Here are some tips to help you get healthier food at a better price.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('strong', [_vm._v("Before you go")])]), _vm._v(" "), _c('p', {
    staticClass: "indents"
  }, [_c('strong', [_vm._v("To stay within your budget, plan meals and make a shopping list before you go to the store.")]), _vm._v(" For example, if you plan to make spaghetti for dinner on Tuesday and tacos on Thursday, your menu might keep you from making a pricey impulse purchase that is not a part of your plan.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('strong', [_vm._v("Store layout")])]), _vm._v(" "), _c('p', {
    staticClass: "indents"
  }, [_c('strong', [_vm._v("Learn the facts about store layout.")]), _vm._v(" Grocery stores are designed to encourage shoppers to spend the most money. A few facts:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("♦  "), _c('strong', [_vm._v("Look low for lower prices.")]), _vm._v(" Stores put generic and less-expensive items below eye-level, typically on the bottom shelf, because they make less money on them.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("♦  "), _c('strong', [_vm._v("Don’t assume that products in end-of-aisle displays are bargains.")]), _vm._v(" They are often put there to get your attention and to move products fast.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("♦  "), _c('strong', [_vm._v("Look for Manager’s Specials.")]), _vm._v(" They are usually good deals and are often marked with bright stickers or signs.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("♦  "), _c('strong', [_vm._v("Be savvy about the tricks of the trade.")]), _vm._v(" Child-oriented products — snacks and cereals — are placed at children’s eye level. Grocers know that children often talk their parents into buying things. Skip those aisles or be ready to set limits if you’re shopping with your children.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('strong', [_vm._v("Unit Pricing: The key to smart shopping")])])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indents"
  }, [_c('strong', [_vm._v("Compare the cost of products by using unit pricing.")]), _vm._v(" Have you ever looked at a box of cereal that is on sale and wondered if it was really a good deal? One of the most helpful tools in the grocery store is unit prices. These are the small codes on the shelf below the product that show how much something costs per unit (ounce, pound). Unit pricing allows you to easily compare brands and package sizes to find the best deal for your money. The unit prices below show that Snappy Rice Cereal is seven cents cheaper per ounce than Crackly Rice Cereal. Unit pricing is not available in all stores or on all items.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg4_1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('strong', [_vm._v("Food Labels")])]), _vm._v(" "), _c('p', {
    staticClass: "indents"
  }, [_vm._v("Using the sample label at right, check out "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/num1.png"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Servings Per Container")]), _vm._v(" and "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/num2.png"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Serving Size")]), _vm._v(" to see how large a serving is and how many people the product will serve. For example, if there are 2 servings listed and you eat the whole container, you’re eating double the calories on the label.")]), _vm._v(" "), _c('p', {
    staticClass: "indents"
  }, [_vm._v("The "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/num3.png"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("%Daily Value")]), _vm._v(" column lists percentages based on recommended daily allowances based on a 2,000 calorie per day diet. For example, a label may show that a serving of the food provides 30 percent of the daily recommended amount of fiber. This means you may need another 70 percent to meet the recommended goal. Remember, this is just an estimate, but it serves as a good guide.")]), _vm._v(" "), _c('p', {
    staticClass: "indents"
  }, [_vm._v("Try to minimize "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/num4.png"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Saturated Fat")]), _vm._v(" and "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/num5.png"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Trans Fat.")]), _vm._v(" These are both bad fats that clog arteries.")]), _vm._v(" "), _c('p', {
    staticClass: "indents"
  }, [_vm._v("The less "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/num6.png"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Cholesterol")]), _vm._v(" and "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/num7.png"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Sodium")]), _vm._v(" you eat, the better. The latest recommendation for sodium is less than 2,300 mg per day for adults and even less for kids, depending on their age.")]), _vm._v(" "), _c('p', {
    staticClass: "indents"
  }, [_vm._v("In addition, try to keep the amount of "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/num8.png"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("added sugars")]), _vm._v(" low since these are sugars and syrups that are added to foods when they are prepared. More sugars means more calories.")]), _vm._v(" "), _c('p', {
    staticClass: "indents"
  }, [_vm._v("Get enough "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/num9.png"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Fiber, "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/num10.png"
    }
  }), _vm._v(" Vitamin D, "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/num11.png"
    }
  }), _vm._v(" Calcium, "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/num12.png"
    }
  }), _vm._v(" Iron,")]), _vm._v(" and "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/num13.png"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Potassium.")])]), _vm._v(" "), _c('p', {
    staticClass: "indents"
  }, [_vm._v("Keep your kids occupied at the store by asking them to read labels. Studying labels will help your family make the best choices.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg4_2.png"
    }
  })])]), _c('p', {
    staticClass: "indents"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Scan the "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/num14.png"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("ingredients.")]), _vm._v(" Companies are required to list product ingredients on the product’s label. Ingredients are listed from the largest amount to the least amount. For example, if sugar is listed first, there is more sugar in the product than any other ingredient. The label at left shows that milled corn is the main ingredient. The next three ingredients are sweeteners: sugar, corn syrup and molasses. When those sweeteners are combined, it may mean there is more sugar than corn in this product.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg5_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('strong', [_vm._v("Produce Section")])]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Buy fresh produce in season.")]), _vm._v(" Most produce is priced lower when it’s in season. Oranges and grapefruit are cheaper and tastier in December and January, the peak of their season. In-season produce is usually displayed at the front of the produce section. Plan your shopping and meals according to what’s in season.")]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Buy the bags.")]), _vm._v(" A bag of apples or potatoes is usually cheaper per unit than individual apples or potatoes.")]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Buy the bargains.")]), _vm._v(" Cabbage, potatoes, carrots, bananas and apples are among the most affordable produce.")]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Buy whole produce.")]), _vm._v(" Prepackaged/precut fruits and vegetables usually cost more than whole produce. There are times when prepackaged/precut produce is priced to sell because it tends to have a shorter shelf life, and store managers want to move it quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Use portion power.")]), _vm._v(" Serve produce in ½ cup portions to make it go further. A large banana can be split between two kids.")]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Only buy what you can use.")]), _vm._v(" Don’t waste produce. Be realistic about how much produce you can prepare and eat before it spoils.")]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Consider frozen or canned vegetables.")]), _vm._v(" If a particular fresh fruit or vegetable is too expensive for your budget, consider buying it frozen or canned.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('strong', [_vm._v("Bread and Grains")])]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Choose "), _c('em', [_vm._v("whole")]), _vm._v(" wheat or "), _c('em', [_vm._v("whole")]), _vm._v(" grain bread.")]), _vm._v(" Even though a label says “wheat” or “multigrain,” the bread isn’t always whole wheat or whole grain. Look for “whole wheat” or “whole grain” on the label and in the ingredient list. Whole wheat and whole grain are much more nutritious than white bread.")]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Don’t let any bread go to waste.")]), _vm._v(" Stale bread is great for making bread crumbs, croutons and French toast.")]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Pick cereals with fiber and sugar in mind.")]), _vm._v(" Look for cereals with 10 or fewer grams of sugar and 3 or more grams of fiber per serving.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('strong', [_vm._v("The Meat Department")])]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Just stew it.")]), _vm._v(" Stew meat tends to be cheaper per pound than other meats and can be tender and flavorful with long, slow cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Cut it up at home.")]), _vm._v(" Boneless, skinless chicken breasts cost much more than a whole chicken. Roasting a whole chicken is easy and when you do cook the whole bird, it can become three meals: roasted chicken, chicken tacos and soup.")]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_vm._v("When there is "), _c('strong', [_vm._v("a great sale on meat,")]), _vm._v(" buy extra and freeze it.")]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_vm._v("Look for "), _c('strong', [_vm._v("cheaper seafood options")]), _vm._v(" like frozen fish filets.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('strong', [_vm._v("Dairy Section")])]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Stick with skim or 1% milk.")]), _vm._v(" It’s cheaper than whole milk and has fewer calories.")]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Stay away from flavored milks.")]), _vm._v(" They’re more expensive and have lots of extra sugar that kids develop a taste for. Get them used to drinking white milk.")]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Consider nonfat dry milk for baking and cooking.")]), _vm._v(" Powdered milk is a great bargain. No one will know the difference if you bake or cook with it.")]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Buy whole cheese instead of shredded or sliced cheese.")]), _vm._v(" It usually costs much less per pound.")]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Buy eggs.")]), _vm._v(" They’re inexpensive, high in protein and can be made quickly into many satisfying meals.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('strong', [_vm._v("A few final shopping tips:")])]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Build your pantry")]), _vm._v(" by buying one pricey item like olive oil or a spice every other shopping trip. Over time you will have a supply of staples that will enhance the flavor of whatever you prepare.")]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Don’t buy drinks other than milk.")]), _vm._v(" Most packaged drinks are overpriced sugar water. Make iced tea (regular or herbal) at home. Add flavor to tea or water with sliced lemons or oranges.")]), _vm._v(" "), _c('p', {
    staticClass: "indentsa"
  }, [_c('strong', [_vm._v("Only use coupons")]), _vm._v(" for foods you really need.")])]), _c('p', {
    staticClass: "h1a",
    attrs: {
      "id": "ch01_2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('strong', [_vm._v("Shop Smart at Farmers Markets")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Shopping at farmers markets is a great way to get local, delicious produce. Take your kids along. If they haven’t already, they may fall in love with fresh fruits and vegetables at the market. Shopping at a farmers’ market is a little different than shopping at a grocery store. These tips can help you make the best choices.")]), _vm._v(" "), _c('p', {
    staticClass: "bulla"
  }, [_vm._v("♦  "), _c('strong', [_vm._v("Find a market near you.")]), _vm._v(" Contact your Cooperative Extension office for up-to-date information on farmers markets in your area.")]), _vm._v(" "), _c('p', {
    staticClass: "bulla"
  }, [_vm._v("♦  "), _c('strong', [_vm._v("Find out which markets accept EBT.")]), _vm._v(" Some farmers markets are equipped to accept Electronic Benefit Transfer (EBT) cards from SNAP customers. Some farmers markets offer “double dollars” when people spend their SNAP benefits at the market.")]), _vm._v(" "), _c('p', {
    staticClass: "bulla"
  }, [_vm._v("♦  "), _c('strong', [_vm._v("Know what’s in season.")]), _vm._v(" Your mouth might be watering for fresh tomatoes but in most cases, Kentucky-grown tomatoes don’t appear at farmers markets until late June. (See the Appendix for the Kentucky Proud Produce Availability Calendar.)")]), _vm._v(" "), _c('p', {
    staticClass: "bulla"
  }, [_vm._v("♦  "), _c('strong', [_vm._v("Look before you buy.")]), _vm._v(" Rather than being swept away by the first ear of corn you see, walk the entire market to see what’s available before you make any purchases. You might find that one vendor’s prices are lower than the others or that there is better-looking corn a few stands away.")]), _vm._v(" "), _c('p', {
    staticClass: "bulla"
  }, [_vm._v("♦  "), _c('strong', [_vm._v("Ask questions.")]), _vm._v(" Farmers are usually happy to answer questions about their fruits and vegetables. They often have great cooking and serving suggestions.")]), _vm._v(" "), _c('p', {
    staticClass: "bulla"
  }, [_vm._v("♦  "), _c('strong', [_vm._v("Bring the kids.")]), _vm._v(" Let each of them pick out one item. Next thing you know, they may be asking to grow a garden.")]), _vm._v(" "), _c('p', {
    staticClass: "bulla"
  }, [_vm._v("♦  "), _c('strong', [_vm._v("Don’t expect a perfect appearance.")]), _vm._v(" Some produce at farmers markets has personality. These vegetables and fruits are usually grown for taste, not appearance. You may find that the produce doesn’t look perfect — a slightly off-center pepper or an apple with a rough skin — but it tastes fantastic.")]), _vm._v(" "), _c('p', {
    staticClass: "bulla"
  }, [_vm._v("♦  "), _c('strong', [_vm._v("Ask for seconds.")]), _vm._v(" Sometimes a farmer will have a basket of perfectly good produce that doesn’t look good enough to put out at the stand. Ask farmers if they have seconds that they are willing to sell at a reduced rate. You may have to cut a few spots out of a potato but it could be well worth it.")]), _vm._v(" "), _c('p', {
    staticClass: "bulla"
  }, [_vm._v("♦  "), _c('strong', [_vm._v("Go late.")]), _vm._v(" For the best deals, go to the farmers’ market late. Farmers often prefer to sell products at a discount rather than load them up and take them home. Keep in mind selling home-grown products is a farmer’s livelihood, so don’t expect deep discounts.")]), _vm._v(" "), _c('p', {
    staticClass: "bulla"
  }, [_vm._v("♦  "), _c('strong', [_vm._v("Keep it simple.")]), _vm._v(" Since the produce you are buying is super fresh, let its natural flavor show when you prepare it. Keep preparation simple. You’ll make cooking easier, and you’ll be likely to try (and eat) even more local foods from the farmers’ market next week. Sliced tomatoes with a little salt, a fresh apple with peanut butter or roasted potatoes are as good as it gets.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg6_1.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3bd7a14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Chapter01.vue
// module id = 72
// module chunks = 0